import { combineEpics } from 'redux-observable';
import type { StateEpic } from '../common/types.tsx';
import routeSync from './route-sync.tsx';
import selectedIssue from './selected-issue.tsx';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default combineEpics(selectedIssue, routeSync) as StateEpic;
